import { render, staticRenderFns } from "./FilterPrograms.vue?vue&type=template&id=1cae3c46"
import script from "./FilterPrograms.vue?vue&type=script&lang=ts"
export * from "./FilterPrograms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports